export default __webpack_public_path__ + "static/media/benefit-area.a6fee3cb.png";